import { HttpContextToken } from '@angular/common/http';

/** Marca a requisição como pública: o AuthInterceptor não envia o token da sessão. */
export const REQUISICAO_PUBLICA = new HttpContextToken<boolean>(() => false);
